import { join } from 'path'
import { SYSTEM_CONFIG_FILES } from './configMerger'
import { RUNDOT_LOOKUP_ORDER } from './rundotPaths'

/**
 * Whether a changed file is a server-config file that should trigger an HMR reload.
 *
 * Scope: legacy base config (`baseConfigGlobs`), legacy `config/*.config.json`, and the
 * rundot layout under BOTH the canonical `rundot/` and legacy `.rundot/` folders — the
 * per-system `SYSTEM_CONFIG_FILES`, `realtime.config.json` (the V2 room-type map, whose
 * deterministic rooms `mergeGameConfigs` now derives into `rooms`), plus
 * `{rundot,.rundot}/simulation/*.json`.
 * Deliberately excludes everything else under those folders — `marketing/**` and
 * `cli_hooks.json`.
 *
 * @param baseConfigGlobs normalized (forward-slash) absolute paths of the env base config candidates
 */
export function isServerConfigChange(
  changedPath: string,
  projectRoot: string,
  baseConfigGlobs: string[],
): boolean {
  const normalizedPath = changedPath.replace(/\\/g, '/')
  const configDir = join(projectRoot, 'config').replace(/\\/g, '/')

  const isRundotConfig = RUNDOT_LOOKUP_ORDER.some(dir => {
    const rundotDir = join(projectRoot, dir).replace(/\\/g, '/')
    return (
      SYSTEM_CONFIG_FILES.some(f => normalizedPath === `${rundotDir}/${f}`) ||
      normalizedPath === `${rundotDir}/realtime.config.json` ||
      (normalizedPath.startsWith(`${rundotDir}/simulation/`) && normalizedPath.endsWith('.json'))
    )
  })

  return (
    baseConfigGlobs.includes(normalizedPath) ||
    (normalizedPath.startsWith(configDir) && normalizedPath.endsWith('.config.json')) ||
    isRundotConfig
  )
}
